import { AnyAbility } from "@casl/ability";
import { createContextualCan, useAbility } from "@casl/react";
import { AppAbility } from "@salon/types/authorization";
import { createContext } from "react";
import { useSalonAbility as useAuthAbility } from "./use-salon-ability";

export const AbilityContext = createContext<AppAbility | undefined>(undefined);
export const Can = createContextualCan(
  AbilityContext.Consumer as unknown as React.Consumer<AnyAbility>
);

interface SalonAbilityProviderProps {
  children: React.ReactNode;
}

export function SalonAbilityProvider({ children }: SalonAbilityProviderProps) {
  // Use the new simplified authorization hook
  const ability = useAuthAbility();

  return <AbilityContext value={ability}>{children}</AbilityContext>;
}

export function useSalonAbility() {
  return useAbility(AbilityContext as unknown as React.Context<AnyAbility>);
}
